<template>
  <!-- pooja, 16-jul-2025, 508-focus on button -->
  <button :class="data.fields.styleInstructions" class="btnCta">
    <rich-text-renderer :data="data.fields.link"></rich-text-renderer>

    <rich-text-renderer v-if="data.fields.buttonActionType === 'JS-CLOSE' || data.fields.buttonActionType === 'JS-PRINT'" :data="data.fields.text">
    </rich-text-renderer>
  </button>
</template>
<script>
export default {
  name: "button-cta",
  props: ["data"],
  created() {
    this.$root.$emit('buttonCta:loaded',this.data.fields.styleInstructions);
  }
};

</script>
<style lang="scss" scoped>
// pooja, 15-jul-2025, 508- color contrast and on visited button link change to black color -->
::v-deep .usa-link:visited,
::v-deep .usa-link:focus,
::v-deep .usa-link:hover,
::v-deep .usa-link:active,
::v-deep .usa-link:visited:focus,
::v-deep .usa-link:visited:hover {
  color: #FFF !important;
}
::v-deep .usa-button {
  p {
    margin: 0;
  }
}

.red-white {
  margin-bottom: 5em;
  ::v-deep a {
    background-color: #e52207;
    font-family: 'Open Sans', 'Source Sans Pro Web', Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
    font-size: 1.06471rem;
    line-height: .93923;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: .25rem;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-weight: 700;
    margin-right: .5rem;
    padding: .75rem 1.25rem;
    text-align: center;
    text-decoration: none;
    width: auto;
    text-transform: uppercase;

    span {
      display: none;
    }

    &:hover {
      span {
        display: none;
      }
    }
  }
}

.blue-white {
  ::v-deep a {
    font-family: 'Open Sans', 'Source Sans Pro Web', Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
    font-size: 1.06471rem;
    line-height: .93923;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #005ea2;
    border: 0;
    border-radius: .25rem;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-weight: 700;
    margin-right: .5rem;
    padding: .75rem 1.25rem;
    text-align: center;
    text-decoration: none;
    width: auto;

    span {
      display: none;
    }

    &:hover {
      color: #FFF;

      span {
        display: none;
      }
    }
  }
}

.close-button,.print-button {
  font-family: 'Open Sans', 'Source Sans Pro Web', Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  font-size: 1.06471rem;
  line-height: .93923;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #005ea2;
  border: 0;
  border-radius: .25rem;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  margin-right: .5rem;
  padding: .75rem 1.25rem;
  text-align: center;
  text-decoration: none;
  width: auto;
  ::v-deep p {
    margin: 0 !important;
    line-height: .93923 !important;
  }
}
.usa-dialog__footer {
  .rich-text {
    display: flex;
    justify-content: center;
  }
}

.btnCta{
  background-color: transparent;
  border: none;
  box-shadow: none;
}

/* Zubair, 22-Apr, New Contact Us Buttons with ICON */
 .blue-btn-agent,
 .blue-btn-chat,
 .blue-btn-assistant {
	   ::v-deep .usa-link {
     display: inline-flex;
     align-items: center;
     position: relative;
     padding: 12px 15px 12px 15px;
     cursor: pointer;
     background: linear-gradient(to bottom, #63628b 0%, #464472 100%);
     color: white;
     border: 1px solid #3a395c;
     border-radius: 15px;
     font-size: 17px;
     font-weight: 500;
     box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2);
     transition: all 0.2s ease;
     text-align: center;
     justify-content: space-between;
     gap: 15px;
     text-decoration: none;
     span {
       display: none;
     }
     &:hover {
       span {
         display: none;
       }
     }
   }
 }

 .blue-btn-agent, .blue-btn-chat, .blue-btn-assistant {
   ::v-deep .usa-link::after {
     content: "";
     margin-left: auto;
     width: 24px;
     height: 24px;
     background-color: white;
     background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23464472'%3E%3Cpath d='M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z'/%3E%3C/svg%3E");
     background-repeat: no-repeat;
     background-position: center;
     background-size: 18px;
     border-radius: 50%;
     box-shadow: 0 1px 2px rgba(0,0,0,0.2);
   }
 }
 
 .blue-btn-agent, .blue-btn-chat, .blue-btn-assistant {
  ::v-deep .usa-link:hover {
    filter: brightness(1.1);
    transform: translateY(-1px);
  }
 }

 .blue-btn-chat {
   ::v-deep .usa-link::before {
     content: "";
     width: 32px;
     height: 32px;
     background-color: white;
     -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2C6.477 2 2 5.582 2 10c0 1.93.843 3.682 2.234 4.986L3 19l4.586-1.529C8.91 17.843 10.414 18 12 18c5.523 0 10-3.582 10-8s-4.477-8-10-8zm-4 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/%3E%3C/svg%3E");
     mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2C6.477 2 2 5.582 2 10c0 1.93.843 3.682 2.234 4.986L3 19l4.586-1.529C8.91 17.843 10.414 18 12 18c5.523 0 10-3.582 10-8s-4.477-8-10-8zm-4 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'/%3E%3C/svg%3E");
     -webkit-mask-repeat: no-repeat;
     mask-repeat: no-repeat;
     -webkit-mask-size: contain;
     mask-size: contain;
   }
 }
 
 .blue-btn-agent {
  ::v-deep .usa-link::before {
    content: "";
    width: 32px;
    height: 32px;
    background-color: white;
    -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 18v-6a9 9 0 0 1 18 0v6'%3E%3C/path%3E%3Cpath d='M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z'%3E%3C/path%3E%3C/svg%3E");
    mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 18v-6a9 9 0 0 1 18 0v6'%3E%3C/path%3E%3Cpath d='M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z'%3E%3C/path%3E%3C/svg%3E");
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
  }
 }

 .blue-btn-assistant {
	  ::v-deep .usa-link::before {
      content: "";
      width: 30px;
      height: 30px;
      background-color: white;
      -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5z'%3E%3C/path%3E%3Cline x1='8' y1='7' x2='16' y2='7'%3E%3C/line%3E%3Cline x1='8' y1='11' x2='16' y2='11'%3E%3C/line%3E%3Cline x1='8' y1='15' x2='12' y2='15'%3E%3C/line%3E%3C/svg%3E");
      mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5z'%3E%3C/path%3E%3Cline x1='8' y1='7' x2='16' y2='7'%3E%3C/line%3E%3Cline x1='8' y1='11' x2='16' y2='11'%3E%3C/line%3E%3Cline x1='8' y1='15' x2='12' y2='15'%3E%3C/line%3E%3C/svg%3E");
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-size: contain;
      mask-size: contain;
   }
 }

/* 
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/
@media (min-width: 320px) and (max-width: 767px) {
  .blue-white {
    ::v-deep a {
      width: 100%;
    }
  }
  .step-6{
    .blue-white{
      ::v-deep a {
      width: 70%;
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .blue-white {
    ::v-deep a {
      width: 100%;
    }
  }
  .step-6{
    .blue-white{
      ::v-deep a {
      width: 70%;
      }
    }
  }
}
 
@media (min-width: 320px) and (max-width: 480px) {
  .red-white{
    ::v-deep a{
      width: 100%;
      margin-bottom: 10px;
    }
  }
  .close-button {
    width: 100%;
  }
  .print-button{
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
